import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import 'tom-select/dist/css/tom-select.css'
import '../stylesheets/tom-select.scss'

export default class extends Controller {
  static targets = ["select"]
  static values = { 
    options: Array,
    placeholder: String
  }

  connect() {
    this.initializeTomSelect()
  }

  disconnect() {
    if (this.tomselect) {
      this.tomselect.destroy()
    }
  }

  initializeTomSelect() {
    if (!this.hasSelectTarget) return

    // Konvertiere die verfügbaren Optionen für TomSelect
    const options = this.optionsValue.map(option => ({
      id: option,
      text: option
    }))

    // Hole die aktuell ausgewählten Werte
    let currentValues = []
    try {
      if (this.selectTarget.value && this.selectTarget.value.trim() !== '') {
        currentValues = JSON.parse(this.selectTarget.value)
        // Stelle sicher, dass es ein Array ist
        if (!Array.isArray(currentValues)) {
          currentValues = []
        }
      }
    } catch (e) {
      console.error('Error parsing current values:', e)
      currentValues = []
    }

        this.tomselect = new TomSelect(this.selectTarget, {
          plugins: ['remove_button'],
          valueField: 'id',
          labelField: 'text',
          searchField: ['text'],
          placeholder: this.placeholderValue || "Optionen auswählen...",
          openOnFocus: true,
          preload: false,
          closeAfterSelect: false, // Bleibt offen für Mehrfachauswahl
          selectOnTab: false, // Verhindert Schließen bei Tab
          maxOptions: 100,
          maxItems: null, // Unbegrenzte Auswahl
          multiple: true,
          options: options,
          items: currentValues,
      render: {
        no_results: function(data, escape) {
          return '<div class="no-results text-sm text-gray-500 py-2">Keine passenden Optionen gefunden</div>'
        },
        option: function(item, escape) {
          return `<div class="option">
            <span class="title text-sm">${escape(item.text)}</span>
          </div>`
        },
        item: function(item, escape) {
          return `<div class="item text-sm bg-blue-100 text-blue-800 px-2 py-1 rounded">${escape(item.text)}</div>`
        },
        option_create: function(data, escape) {
          return '<div class="create text-sm text-green-600">Neue Option "' + escape(data.input) + '" hinzufügen</div>'
        }
      },
          onChange: (value) => {
            // Konvertiere die ausgewählten Werte zu JSON und speichere sie
            const selectedValues = Array.isArray(value) ? value : []
            
            // Filtere leere Werte heraus
            const filteredValues = selectedValues.filter(v => v && v.trim && v.trim() !== '' || v && !v.trim)
            
            // Immer speichern - auch leere Arrays
            this.selectTarget.value = JSON.stringify(filteredValues)
            
            // KEIN automatisches Speichern bei jeder Auswahl
            // Nur den Wert im Input-Feld aktualisieren
          },
          onBlur: () => {
            // Nur den Wert aktualisieren, kein automatisches Speichern
            // Das Formular wird über den "Speichern"-Button gespeichert
            this.selectTarget.dispatchEvent(new Event('change', { bubbles: true }))
          }
    })
  }
}

